export default __webpack_public_path__ + "static/media/negotiation.cf0264b8.svg";